import { exists } from '@/api'

export interface BatchTrcAcceptMarcRegisterCondition {
  startNumFrom: string
  startNumTo: string
  vendorType: string
  traderType: string
  donorType: string
  acceptDate: string
  acceptType: string
  budgetYear: string
  budgetBranch: string
  budgetDepartment: string
  expenseCode: string
  equipType: string
  priceType: string
  isCalcPrice: boolean
  collectionStatus: string
  branch: string
  shelfType: string
  collectionType: string
  department: string
  handlingType: string
  storeType: string
  appendixCode: string
  isCheckDigit: boolean
  memo: string
}

export function BatchTrcAcceptMarcRegisterConditionFromJSON(
  json: any
): BatchTrcAcceptMarcRegisterCondition {
  const _json = JSON.parse(json)

  return {
    startNumFrom: exists(_json, 'start_num_from') ? _json.start_num_from : '',
    startNumTo: exists(_json, 'start_num_to') ? _json.start_num_to : '',
    vendorType: exists(_json, 'vendor_type') ? _json.vendor_type : '1',
    traderType: exists(_json, 'trader_type') ? _json.trader_type : '',
    donorType: exists(_json, 'donor_type') ? _json.donor_type : '',
    acceptDate: exists(_json, 'accept_date') ? _json.accept_date : '',
    acceptType: exists(_json, 'accept_type') ? _json.accept_type : '',
    budgetYear: exists(_json, 'budget_year') ? _json.budget_year : '',
    budgetBranch: exists(_json, 'budget_branch') ? _json.budget_branch : '',
    budgetDepartment: exists(_json, 'budget_department')
      ? _json.budget_department
      : '',
    expenseCode: exists(_json, 'expense_code') ? _json.expense_code : '',
    equipType: exists(_json, 'equip_type') ? _json.equip_type : '',
    priceType: exists(_json, 'price_type') ? _json.price_type : '1',
    isCalcPrice: exists(_json, 'is_calc_price') ? _json.is_calc_price : false,
    collectionStatus: exists(_json, 'collection_status')
      ? _json.collection_status
      : '',
    branch: exists(_json, 'branch') ? _json.branch : '',
    shelfType: exists(_json, 'shelf_type') ? _json.shelf_type : '',
    collectionType: exists(_json, 'collection_type')
      ? _json.collection_type
      : '',
    department: exists(_json, 'department') ? _json.department : '',
    handlingType: exists(_json, 'handling_type') ? _json.handling_type : '',
    storeType: exists(_json, 'store_type') ? _json.store_type : '',
    appendixCode: exists(_json, 'appendix_code') ? _json.appendix_code : '',
    isCheckDigit: exists(_json, 'is_check_digit')
      ? _json.is_check_digit
      : false,
    memo: exists(_json, 'memo') ? _json.memo : ''
  }
}
